const FULL_ACCESS_ROLES = [
  "owner",
  "superadmin",
  "superadministrator"
];

export function normalizeRole(role) {
  return String(role || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");
}

export function getUserRole(user = {}) {
  return normalizeRole(
    user.status ||
      user.role ||
      user.level ||
      user.jabatan ||
      user.user_level ||
      ""
  );
}

export function hasFullMenuAccess(user = {}) {
  return FULL_ACCESS_ROLES.includes(getUserRole(user));
}

export function normalizePermissionPath(path) {
  const clean = String(path || "").replace(/\/$/, "");
  return clean || "/";
}

export function requiresExplicitPermission(path) {
  return ["/dashboard-owner"].includes(normalizePermissionPath(path));
}

const EQUIVALENT_PERMISSIONS = {
  "/kasir/rincian-pengeluaran-kas": [
    "/kasir/rincian-pengeluaran-kas",
    "/kasir/pengeluaran-kas",
    "/kasir/laporan-pengeluaran-kas-tanggal",
    "/kasir/laporan-pengeluaran-kas-pos"
  ]
};

export function hasMenuPermission(perms, targetPath) {
  const cleanTarget = normalizePermissionPath(targetPath);
  const normalizedPerms = (Array.isArray(perms) ? perms : []).map(
    normalizePermissionPath
  );
  const allowedPaths = EQUIVALENT_PERMISSIONS[cleanTarget] || [cleanTarget];
  return allowedPaths.some(p => normalizedPerms.includes(p));
}
